import React from 'react';

import type { StepCardProps } from './types';

import styles from './styles.module.scss';

export const StepCard = (props: StepCardProps): React.ReactElement => {
  const { icon, stepNumber, title, description } = props;

  return (
    <article className={styles.card}>
      <div className={styles.iconWrap} aria-hidden>
        {icon}
      </div>
      <div className={styles.body}>
        <h3 className={styles.title}>
          {stepNumber}. {title}
        </h3>
        <p className={styles.description}>{description}</p>
      </div>
    </article>
  );
};
